import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from '../services/common.service';

@Pipe({
  name: 'sportUrl',
})
export class SportUrlPipe implements PipeTransform {
  constructor(private _common: CommonService) {}
  transform(routerLink: any, ...args: any[]): any {
    routerLink = routerLink.split('?');
    routerLink = routerLink[0].split('/');
    if (this._common.sports.includes(routerLink[1])) {
      routerLink[1] = args[0].toLowerCase();
    } else {
      routerLink[0] = args[0].toLowerCase();
    }
    if (!routerLink[0] && !routerLink[1]) {
      routerLink.splice(0, 1);
    }
    if (routerLink.includes('expert-picks')) {
      let link = [routerLink[0], routerLink[1]];
      if (routerLink[2]) {
        link.push(routerLink[2]);
      }
      return link;
    }
    return routerLink;
  }
}
